// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MenuLinks-item-link {
  font-weight: 500;
  font-size: var(--font-paragraph);
  font-family: var(--font-family);
  line-height: var(--font-paragraph-line);
  color: var(--footer-color-button-text);
  text-decoration: none;
  padding-bottom: var(--spacing-extra-small) !important;
  padding: var(--spacing-small) var(--spacing-extra-small);
}
.MenuLinks-item-link:hover {
  color: var(--footer-color-button-text);
  filter: brightness(1.2);
  text-decoration: none;
}

.MenuLinks-item-image {
  object-fit: var(--footer-logo-object-fit);
  box-sizing: var(--footer-logo-box-sizing);
  max-width: var(--footer-size-logo-maxwidth);
  max-height: var(--footer-size-logo-maxheight);
  width: 100%;
  height: 100%;
  padding: var(--spacing-small) var(--spacing-extra-small);
}

@media screen and (max-width: 768px) {
  .MenuLinks-item-link {
    img {
      max-width: var(--footer-size-logo-maxwidth-mobile-md);
    }
  }
}

@media screen and (max-width: 576px) {
  .MenuLinks-item-link {
    img {
      max-width: var(--footer-size-logo-maxwidth-mobile-sm);
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GenericFooter/components/MenuLinks/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,+BAA+B;EAC/B,uCAAuC;EACvC,sCAAsC;EACtC,qBAAqB;EACrB,qDAAqD;EACrD,wDAAwD;AAC1D;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,2CAA2C;EAC3C,6CAA6C;EAC7C,WAAW;EACX,YAAY;EACZ,wDAAwD;AAC1D;;AAEA;EACE;IACE;MACE,qDAAqD;IACvD;EACF;AACF;;AAEA;EACE;IACE;MACE,qDAAqD;IACvD;EACF;AACF","sourcesContent":[".MenuLinks-item-link {\n  font-weight: 500;\n  font-size: var(--font-paragraph);\n  font-family: var(--font-family);\n  line-height: var(--font-paragraph-line);\n  color: var(--footer-color-button-text);\n  text-decoration: none;\n  padding-bottom: var(--spacing-extra-small) !important;\n  padding: var(--spacing-small) var(--spacing-extra-small);\n}\n.MenuLinks-item-link:hover {\n  color: var(--footer-color-button-text);\n  filter: brightness(1.2);\n  text-decoration: none;\n}\n\n.MenuLinks-item-image {\n  object-fit: var(--footer-logo-object-fit);\n  box-sizing: var(--footer-logo-box-sizing);\n  max-width: var(--footer-size-logo-maxwidth);\n  max-height: var(--footer-size-logo-maxheight);\n  width: 100%;\n  height: 100%;\n  padding: var(--spacing-small) var(--spacing-extra-small);\n}\n\n@media screen and (max-width: 768px) {\n  .MenuLinks-item-link {\n    img {\n      max-width: var(--footer-size-logo-maxwidth-mobile-md);\n    }\n  }\n}\n\n@media screen and (max-width: 576px) {\n  .MenuLinks-item-link {\n    img {\n      max-width: var(--footer-size-logo-maxwidth-mobile-sm);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
